import React from "react";
import { User, Bot } from "lucide-react";
import "./ParticipantTypeToggle.css";

/**
 * Small two-state switch for marking a session participant as a person or automata.
 * Shows a person icon (User) and a robot icon (Bot) from lucide-react.
 * Person is the default state.
 */
function ParticipantTypeToggle({ isAutomata = false, onChange, disabled = false }) {
  const handlePerson = () => {
    if (!disabled && isAutomata) {
      onChange(false);
    }
  };

  const handleBot = () => {
    if (!disabled && !isAutomata) {
      onChange(true);
    }
  };

  return (
    <div
      className="participant-type-toggle"
      title={isAutomata ? "Automa/Dummy" : "Person participant"}
      aria-label={isAutomata ? "Automa/Dummy" : "Person participant"}
    >
      <button
        type="button"
        className={`participant-type-toggle__option ${!isAutomata ? "participant-type-toggle__option--active" : ""}`}
        onClick={handlePerson}
        disabled={disabled}
        aria-pressed={!isAutomata}
        title="Person participant"
        data-testid="person-toggle"
      >
        <User size={14} />
      </button>
      <button
        type="button"
        className={`participant-type-toggle__option ${isAutomata ? "participant-type-toggle__option--active" : ""}`}
        onClick={handleBot}
        disabled={disabled}
        aria-pressed={isAutomata}
        title="Automa/Dummy"
        data-testid="bot-toggle"
      >
        <Bot size={14} />
      </button>
    </div>
  );
}

export default ParticipantTypeToggle;
